import type { ItemType } from '@/types/item'
import { getEquipInfoList } from './equip'
import type { RuneItemType } from '@/types/rune'
import { runeCollection } from '@/core/rune'
import type { RelicItemType } from '@/types/relic'
import { relicCollection } from '@/core/relic'
import type { SkillItemType } from '@/types/skill'
import { skillCollection } from '@/core/skill'

// 排序物品列表
export function sortItemList(itemList: ItemType[]) {
  const equipInfoList = getEquipInfoList(itemList)
  const qualityOrder = ['supreme', 'myth', 'darkGold', 'peerless', 'antiquity', 'legend', 'unique', 'epic', 'race', 'normal']
  const typeOrder = ['weapon', 'helmet', 'armor', 'shoes', 'jewelry']
  equipInfoList.sort((a, b) => {
    const qualityIndexA = qualityOrder.indexOf(a.quality)
    const qualityIndexB = qualityOrder.indexOf(b.quality)
    const reinforcedLevelA = a.reinforcedLevel
    const reinforcedLevelB = b.reinforcedLevel
    if (a.quality !== 'supreme' && b.quality !== 'supreme') {
      if (reinforcedLevelA === 0 && reinforcedLevelB > 0) return 1
      else if (reinforcedLevelA > 0 && reinforcedLevelB === 0) return -1
    }
    if (qualityIndexA !== qualityIndexB) {
      return qualityIndexA - qualityIndexB
    }
    if (reinforcedLevelA !== reinforcedLevelB) {
      return reinforcedLevelB - reinforcedLevelA
    }

    if ((a.quality === 'unique' && b.quality === 'unique') || (a.quality === 'peerless' && b.quality === 'peerless')) {
      const suitIdA = a.attrs.suit!.id
      const suitIdB = b.attrs.suit!.id
      if (suitIdA < suitIdB) return -1
      if (suitIdA > suitIdB) return 1
    }

    if (a.quality === 'supreme' && b.quality === 'supreme') {
      const supremeLevelA = a.supremeAttrs?.level || 0
      const supremeLevelB = b.supremeAttrs?.level || 0
      if (supremeLevelA !== supremeLevelB) {
        return supremeLevelB - supremeLevelA
      }
    }

    const typeIndexA = typeOrder.indexOf(a.type)
    const typeIndexB = typeOrder.indexOf(b.type)
    if (typeIndexA !== typeIndexB) {
      return typeIndexA - typeIndexB
    }

    return b.name.localeCompare(a.name)
  })
  const res = equipInfoList.map(
    ({
      id,
      equipId,
      reinforcedLevel,
      starAttrs,
      quality,
      enchantAttr,
      darkGoldAttrs,
      supremeAttrs,
      refineAttr,
      engraveAttr,
      supremeEngraveAttr,
      isLock,
    }) => ({
      id,
      equipId,
      reinforcedLevel,
      quality,
      starAttrs,
      enchantAttr,
      darkGoldAttrs,
      supremeAttrs,
      refineAttr,
      engraveAttr,
      supremeEngraveAttr,
      isLock,
    }),
  )
  return res
}

export function sortRuneItem(runeList: RuneItemType[], soulType: number) {
  const qualityOrder = ['antiquity', 'legend', 'unique', 'epic', 'race', 'normal']
  runeList.sort((a, b) => {
    const qualityIndexA = qualityOrder.indexOf(a.quality)
    const qualityIndexB = qualityOrder.indexOf(b.quality)
    if (qualityIndexA !== qualityIndexB) {
      return qualityIndexA - qualityIndexB
    }
    const runeSoulTypeA = runeCollection[a.runeId].soulType
    const runeSoulTypeB = runeCollection[b.runeId].soulType
    if (runeSoulTypeA === soulType && runeSoulTypeB !== soulType) {
      return -1
    } else if (runeSoulTypeA !== soulType && runeSoulTypeB === soulType) {
      return 1
    }

    return a.runeId - b.runeId
  })
}

export function sortRelicItem(list: RelicItemType[]) {
  const qualityOrder = ['antiquity', 'legend', 'unique', 'epic', 'race', 'normal']
  const elementOrder = ['wind', 'fire', 'water', 'soil']

  list.sort((a, b) => {
    const qualityIndexA = qualityOrder.indexOf(a.quality)
    const qualityIndexB = qualityOrder.indexOf(b.quality)
    if (qualityIndexA !== qualityIndexB) {
      return qualityIndexA - qualityIndexB
    }

    if (a.count !== b.count) {
      return b.count - a.count
    }

    const relicElementA = relicCollection[a.relicId].element
    const relicElementB = relicCollection[b.relicId].element
    const relicElementIndexA = elementOrder.indexOf(relicElementA)
    const relicElementIndexB = elementOrder.indexOf(relicElementB)
    if (relicElementIndexA !== relicElementIndexB) {
      return relicElementIndexA - relicElementIndexB
    }

    return b.relicId - a.relicId
  })
}

export function sortSkillItem(list: SkillItemType[]) {
  const qualityOrder = ['antiquity', 'legend', 'unique', 'epic', 'race', 'normal']
  const elementOrder = ['wind', 'fire', 'water', 'soil']

  list.sort((a, b) => {
    const qualityIndexA = qualityOrder.indexOf(a.quality)
    const qualityIndexB = qualityOrder.indexOf(b.quality)
    if (qualityIndexA !== qualityIndexB) {
      return qualityIndexA - qualityIndexB
    }

    const relicElementA = skillCollection[a.skillId].element[0]
    const relicElementB = skillCollection[b.skillId].element[0]
    const relicElementIndexA = elementOrder.indexOf(relicElementA)
    const relicElementIndexB = elementOrder.indexOf(relicElementB)
    if (relicElementIndexA !== relicElementIndexB) {
      return relicElementIndexA - relicElementIndexB
    }

    return b.skillId - a.skillId
  })
}
